import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Step5EquipmentConfirm({ formData, setFormData }) {
  const navigate = useNavigate();

  const handleNext = () => {
    const token = localStorage.getItem('token');

    if (!token) {
      localStorage.setItem('redirectAfterLogin', '/summary');
      navigate('/login');
      return;
    }

    navigate('/summary', { state: { formData } });
  };

  const isAdvanced = formData.fitnessExperience === 3;

  return (
    <div className="space-y-6">
      <h2 className="text-lg font-bold mb-4">تجهیزات در دسترس</h2>

      <select
        value={formData.EquipmentAccess ?? ''}
        onChange={(e) =>
          setFormData({
            ...formData,
            EquipmentAccess: parseInt(e.target.value),
          })
        }
        className="w-full p-3 rounded-xl border-2 bg-white dark:bg-[#2a2f3b] dark:border-gray-600"
      >
        <option value="">انتخاب کنید...</option>
        {isAdvanced ? (
          <option value="2">باشگاه کامل</option>
        ) : (
          <>
            <option value="0">فقط وزن بدن</option>
            <option value="1">وزن بدن + دمبل</option>
            <option value="2">وزن بدن و کش سی ایکس تراباند</option>
            <option value="3">باشگاه کامل</option>
          </>
        )}
      </select>

      <div className="text-center">
        <button
          onClick={handleNext}
          disabled={
            formData.equipmentAccess === null || formData.equipmentAccess === ''
          }
          className="w-full bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-xl disabled:opacity-50"
        >
          ادامه
        </button>
      </div>
    </div>
  );
}
